<template>
  <div>
    <!--遮罩-->
    <div class="showImg" @click="yinImg" v-if="showImg">
      <img :src="urlSrc" alt="#" @click.stop />
    </div>
    <!-- 顶部 banner -->
    <Col span="24">
      <div class="banner-box">
        <img class="banner-img" src="../../static/img/home/core.png" alt="#" />
        <div class="banner_font">
          <div class="banner_font1">关于我们</div>
          <div class="banner_font2"></div>
          <div class="banner_font3">深化核心业务 不断创新突破</div>
        </div>
      </div>
    </Col>
    <!-- 导航栏 -->
    <Col span="24">
      <div class="nav-bar">
        <ul class="navigation">
          <li
            @click="we"
            :style="{ backgroundColor: MonitorColor, color: fontColor1 }"
          >
            关于我们
          </li>
          <li
            @click="Qualification"
            :style="{ backgroundColor: SkipVR, color: fontColor2 }"
          >
            企业资质
          </li>
        </ul>
      </div>
    </Col>
    <!--企业荣誉-->
    <Row
      justify="center"
      type="flex"
      style="background-color: white; padding-top: 40px"
    >
      <Col :xs="20" :sm="20" :lg="15" :xl="15">
        <div style="display: flex">
          <div style="width: 3px; height: 32px; background-color: #337ab7">
            |
          </div>
          <div
            style="
              color: #498ad4;
              font-size: 24px;
              font-family: 微软雅黑, serif;
              margin: 0 0 0 14px;
            "
          >
            企业荣誉
          </div>
        </div>
      </Col>
    </Row>
    <!-- 企业荣誉图片 -->
    <Row justify="center" type="flex" style="background-color: white">
      <Col :xs="20" :sm="20" :lg="15" :xl="15">
        <Row justify="center" type="flex">
          <Col
            :xs="16"
            :sm="16"
            :lg="9"
            :xl="9"
            class="col_jian_01"
            v-for="(item, index) in imgPatent"
            :key="index"
          >
            <div class="col_div_01">
              <img
                style="height: 290px"
                :src="item.url"
                @click="getShowImg(item.url)"
                alt="#"
              />
            </div>
            <div class="colo_div_span">
              <span>{{ item.explain }}</span>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
    <!-- 企业资质图片 -->
    <Row justify="center" type="flex" style="background-color: white">
      <Col :xs="20" :sm="20" :lg="15" :xl="15">
        <Row justify="center" type="flex">
          <Col
            :xs="16"
            :sm="16"
            :lg="9"
            :xl="9"
            class="col_jian_01"
            v-for="(item, index) in imgPatentThree"
            :key="index"
          >
            <div class="col_div_01">
              <img
                style="height: 290px"
                :src="item.url"
                @click="getShowImg(item.url)"
                alt="#"
              />
            </div>
            <div class="colo_div_span">
              <span>{{ item.explain }}</span>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
    <!-- 企业荣誉图片 -->
    <Row justify="center" type="flex" style="background-color: white">
      <Col :xs="20" :sm="20" :lg="15" :xl="15">
        <Row justify="center" type="flex">
          <Col
            :xs="16"
            :sm="16"
            :lg="9"
            :xl="9"
            class="col_jian_01"
            v-for="(item, index) in imgPatent1"
            :key="index"
          >
            <div class="col_div_01">
              <img
                style="height: 290px"
                :src="item.url"
                @click="getShowImg(item.url)"
                alt="#"
              />
            </div>
            <div class="colo_div_span">
              <span>{{ item.explain }}</span>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
    <!-- 企业资质图片 -->
    <Row justify="center" type="flex" style="background-color: white">
      <Col :xs="20" :sm="20" :lg="15" :xl="15">
        <Row justify="center" type="flex">
          <Col
            :xs="12"
            :sm="12"
            :lg="6"
            :xl="6"
            class="col_jian_01"
            v-for="(item, index) in imgPatentSecond"
            :key="index"
          >
            <div class="col_div_01">
              <img
                style="width: 220px; height: 290px"
                :src="item.url"
                @click="getShowImg(item.url)"
                alt="#"
              />
            </div>
            <div class="colo_div_span">
              <span>{{ item.explain }}</span>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
    <!--企业专利-->
    <Row
      justify="center"
      type="flex"
      style="background-color: white; padding-top: 40px"
    >
      <Col :xs="20" :sm="20" :lg="15" :xl="15">
        <div style="display: flex">
          <div style="width: 3px; height: 32px; background-color: #337ab7">
            |
          </div>
          <div
            style="
              color: #498ad4;
              font-size: 24px;
              font-family: 微软雅黑, serif;
              margin: 0 0 0 14px;
            "
          >
            企业专利
          </div>
        </div>
      </Col>
    </Row>
    <Row justify="center" type="flex" style="background-color: white">
      <Col :xs="20" :sm="20" :lg="15" :xl="15">
        <Row justify="center" type="flex">
          <Col
            :xs="12"
            :sm="12"
            :lg="6"
            :xl="6"
            class="col_jian_01"
            v-for="(item, index) in imgPatentOne"
            :key="index"
          >
            <div class="col_div_01">
              <img
                style="width: 220px; height: 290px"
                :src="item.url"
                @click="getShowImg(item.url)"
                alt="#"
              />
            </div>
            <div class="colo_div_span">
              <!-- <span>{{ item.explain }}</span> -->
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  name: "Enterprise",
  data() {
    return {
      showImg: false,
      urlSrc: "",
      imgPatent: [
        {
          url: "../../static/img/EnterPrise/PatentOne/patent01.png",
          explain: "高新技术企业证书",
        },
        {
          url: "../../static/img/EnterPrise/PatentOne/renzheng.png",
          explain: "大数据认定证书",
        },
      ],
      imgPatent1: [
        {
          url: "../../static/img/EnterPrise/PatentOne/jinbujiang.png",
          explain: "河南省科学技术厅科学技术一等奖",
        },
        {
          url: "../../static/img/EnterPrise/PatentOne/BIM.jpg",
          explain: "河南省第二届建设工程“中原杯”BIM大赛获奖证书",
        },
      ],
      imgPatentSecond: [
        {
          url: "../../static/img/EnterPrise/PatentOne/construction.png",
          explain: "中州建设科学技术奖",
        },
        {
          url: "../../static/img/EnterPrise/PatentOne/quality.png",
          explain: "质量管理体系认证证书",
        },
        {
          url: "../../static/img/EnterPrise/PatentOne/shengtai.png",
          explain: "产业生态联盟",
        },
      ],
      imgPatentThree: [
        {
          url: "../../static/img/EnterPrise/PatentOne/enterprises.png",
          explain: "郑州市专精特新中小企业",
        },
        {
          url: "../../static/img/EnterPrise/PatentOne/xiehui.jpg",
          explain: "河南省建设信息管理协会副会长单位",
        },
      ],
      imgPatentOne: [
        // 平面极差智能测量仪
        {
          url: "../../static/img/EnterPrise/PatentOne/plane.png",
          explain: "电流变液平面极差智能测量仪",
        },
        //智能靠尺
        {
          url: "../../static/img/EnterPrise/PatentOne/Topplate.png",
          explain: "智能靠尺",
        },
        // 激光测距仪
        {
          url: "../../static/img/EnterPrise/PatentOne/rangefinder.png",
          explain: "智能激光测距仪",
        },
        // 智能卷尺
        {
          url: "../../static/img/EnterPrise/PatentOne/Tapemeasure.png",
          explain: "智能卷尺",
        },
        // 智能卡尺
        {
          url: "../../static/img/EnterPrise/PatentOne/Caliper.png",
          explain: "智能游标卡尺",
        },
        // 新型激光扫平仪
        {
          url: "../../static/img/EnterPrise/PatentOne/re01.png",
          explain: "新型激光扫平仪",
        },
        // 新型靠尺
        {
          url: "../../static/img/EnterPrise/PatentOne/rule.png",
          explain: "新型靠尺",
        },
        // 可拆卸智能靠尺
        {
          url: "../../static/img/EnterPrise/PatentOne/rule01.png",
          explain: "可拆卸智能靠尺",
        },
        // 智能混凝土回弹仪
        {
          url: "../../static/img/EnterPrise/PatentOne/beton.png",
          explain: "智能混凝土回弹仪",
        },
        // 数显楔形塞尺
        {
          url: "../../static/img/EnterPrise/PatentOne/saichi.png",
          explain: "数显楔形塞尺",
        },
        // 安全标志识别装置
        {
          url: "../../static/img/EnterPrise/PatentOne/identification.png",
          explain: "安全标志识别装置",
        },
        // 模拟灭火演示装置
        {
          url: "../../static/img/EnterPrise/PatentOne/extinguishing.png",
          explain: "模拟灭火演示装置",
        },
      ],
      imgSrc: [
        {
          url: "../../static/img/EnterPrise/patent/AR虚拟质量样板APP软件V1.0.jpg",
          explain: "AR虚拟质量样板APP软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR三合一综合体验软件.jpg",
          explain: "VR三合一综合体验软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR地铁安全事故体验软件V1.0.jpg",
          explain: "VR地铁安全事故体验软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR安全体验馆软件V2.0.jpg",
          explain: "VR安全体验馆软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR工程事故体验软件1.0.jpg",
          explain: "VR工程事故体验软件1",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR工程事故体验软件著作权证书.jpg",
          explain: "VR工程事故体验软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR引江济淮工程体验软件V1.0.jpg",
          explain: "VR引江济淮工程体验软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR施工安全体验软件著作权证书.jpg",
          explain: "VR施工安全体验软件著作权证书",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR机械事故VR体验软件V1.0.jpg",
          explain: "VR机械事故VR体验软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR消防逃生体验软件V1.0.jpg",
          explain: "VR消防逃生体验软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/VR路桥工程事故体验软件.jpg",
          explain: "VR路桥工程事故体验软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/安全标志标识.jpg",
          explain: "安全标志标识",
        },
        {
          url: "../../static/img/EnterPrise/patent/安全隐患排查.jpg",
          explain: "安全隐患排查",
        },
        {
          url: "../../static/img/EnterPrise/patent/建筑工程AR二十三项质量样板APP软件.jpg",
          explain: "建筑工程AR二十三项质量样板APP软件",
        },
        {
          url: "../../static/img/EnterPrise/patent/建筑工程AR质量样板著作权证书.jpg",
          explain: "建筑工程AR质量样板著作权证书",
        },
        {
          url: "../../static/img/EnterPrise/patent/建筑工程VR质量样板软件著作权证书.jpg",
          explain: "建筑工程VR质量样板软件著作权证书",
        },
        {
          url: "../../static/img/EnterPrise/patent/技能知识宝典软件V1.0.jpg",
          explain: "技能知识宝典软件",
        },
      ],
      menuTheme: "light",
      MonitorColor: "#1966ff",
      SkipVR: "#fff",
      //
      fontColor1: "#fff",
      fontColor2: "#1966ff",
    };
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
  methods: {
    /*遮罩*/
    getShowImg(url) {
      this.showImg = true;
      this.urlSrc = encodeURI(url);
    },
    /*隐藏遮罩层*/
    yinImg() {
      this.showImg = false;
    },
    // 跳转关于我们
    we() {
      this.$router.push({
        path: "/home/AboutUs",
      });
      this.MonitorColor = "#fff";
      this.SkipVR = "#1966ff";
      this.SkipQuality = "#1966ff";
      //
      this.fontColor1 = "#1966ff";
      this.fontColor2 = "#fff";
      this.fontColor3 = "#fff";
    },
    Qualification() {},
  },
};
</script>
<style scoped>
.col_jian_01 {
  cursor: pointer;
  background: white;
  border: 1px solid #e1e1e1;
  margin: 40px 0 20px 10px;
  box-shadow: 0 0 20px rgb(0 0 0 / 25%);
  border-radius: 10px;
}
.col_div_01 {
  height: 320px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.col_div_00 {
  height: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.colo_div_span {
  color: #14bce8;
  text-align: center;
  margin: 6px 0 10px 0;
  font-size: 16px;
  overflow: hidden;
  left: 20px;
}
/*--------遮罩------------*/
.showImg {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
}
.showImg img {
  max-width: 70%;
  max-height: 85vh;
  cursor: default;
}
/*------------------------*/
.navigation li .router-link-active {
  color: blue;
  font-weight: bolder;
}
/* banner 区域 */
.banner-box {
  position: relative;
  width: 100%;
  height: 500px;
  overflow: hidden;
}
.banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
/* banner 文字 */
.banner_font {
  position: absolute;
  top: 50%;
  right: 15%;
  transform: translateY(-50%);
  z-index: 10;
}
.banner_font1 {
  font-size: 30px;
  color: #fff;
  white-space: nowrap;
}
.banner_font2 {
  width: 120px;
  height: 2px;
  background: #fff;
  margin: 15px 0;
}
.banner_font3 {
  font-size: 18px;
  color: #fff;
  white-space: nowrap;
}
/* 导航栏 */
.nav-bar {
  width: 100%;
  height: 60px;
  background: #1966ff;
}
.navigation {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}
.navigation li {
  width: 120px;
  height: 100%;
  line-height: 60px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  transition: 0.2s;
}
.navigation li:hover {
  background: #2d8cf0;
}
</style>



// WEBPACK FOOTER //
// src/components/Enterprise.vue